export const GET_MAP_CONTRACT = `
  query GetMapContract($mapId: String!) {
    getMapContract(mapId: $mapId) {
      error {
        code
        message
        statusCode
      }
      data {
        mapId
        mpeId
        mapType
        contractName
        startDate
        endDate
        creditPct
        committedSpend
        eligibleProductCodes
        accountsInScope
        tagValue
        status
        taggedSpendMTD
        taggedSpendYTD
        totalCreditsReceived
        createdDate
        createdBy
        updatedDate
        lastProcessedDate
      }
    }
  }
`
